import styles from './List.module.scss';
import { Spinner } from '../spinners/Spinner';

interface Props {
  children?: React.ReactNode;
  loading?: boolean | string;
}

export function Listbox(props: Props) {
  return props.loading ? (
    <Spinner
      message={typeof props.loading == 'string' ? props.loading : undefined}
    />
  ) : (
    <ul className={styles['list']} role="listbox">
      {props.children}
    </ul>
  );
}
